import { Modal } from 'antd';
import ScoringListModal from 'pages/Scoring/ScoringListModal';
import React from 'react';
import { ScoringSelectedType } from './ScoringSelect';

export type ScoringSearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setScoring?: (
    Scoring: ScoringSelectedType
  ) => void;
};

const ScoringSearchModal = ({
  onCancel,
  visible,
  setScoring,
}: ScoringSearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <ScoringListModal
        onSelect={setScoring}
      />
    </Modal>
  );
};

export default ScoringSearchModal;
